import { __assign } from "tslib";
import React from 'react';
import { View } from 'react-native';
// Custom
import c from '../styles/_colors';
import PnmacMobileButton from '../Uibutton/MobileButton/Button.js';
import { platformUtils } from '../utils';
var BottomButton = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: s.container
  }, /*#__PURE__*/React.createElement(PnmacMobileButton, __assign({}, props)));
};
export var PnmacBottomButtonReminder = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: {
      backgroundColor: c.white,
      borderTopColor: c.whiteShade,
      borderTopWidth: 1,
      borderBottomWidth: platformUtils.ifIphoneX(8, 0),
      borderBottomColor: c.white,
      padding: 10,
      paddingHorizontal: 20,
      marginTop: 25
    }
  }, /*#__PURE__*/React.createElement(PnmacMobileButton, __assign({}, props)));
};
export var PnmacDullBottomButton = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: [s.container, {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: 15
    }]
  }, props.children);
};
export default BottomButton;
var s = {
  container: {
    backgroundColor: c.white,
    borderTopColor: c.whiteShade,
    borderTopWidth: 1,
    borderBottomWidth: platformUtils.ifIphoneX(8, 0),
    borderBottomColor: c.white,
    padding: 10,
    paddingHorizontal: 20,
    paddingBottom: platformUtils.ifIphoneX(44, 20)
  }
};